export default {
  app: {
    privacy: {
      policy: 'Privatlivspolitik',
      expansive: 'Ved at bruge Expansive accepterer du Expansive {action}',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Session udløbet',
    sessionExpiredDescription:
      'Din session er udløbet. Log venligst ind igen for at fortsætte med at bruge applikationen.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Vælg sprog',
      chooseLanguageDescription:
        'Vælg dit foretrukne sprog til applikationen. Dette vil ændre sproget for brugerfladen og indholdet.',
    },
    userSelection: {
      cancel: 'Annuller',
      createNewUser: 'Deres navn er ikke på listen',
      newUser: 'Ny bruger',
      selectAnExistingUser: 'Vælg en eksisterende bruger',
      selectUserHint: 'Vælg en eksisterende bruger eller opret en ny for at fortsætte.',
      startTypingToSearch: 'Begynd at skrive...',
    },
    verification: {
      codeVerification: {
        continue: 'Fortsæt',
        header: 'Indtast adgangskode til stedet',
        invalidCode: 'Ugyldig kode, prøv venligst igen.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Fortsæt uden at bekræfte placering',
        enterSiteAccessCode: 'Indtast adgangskode til stedet',
        locationNotEnabledOrAvailable: 'Hvorfor ser jeg dette?',
        notAvailable: {
          description: 'GPS-placering understøttes ikke på denne enhed.',
          header: 'Placering understøttes ikke',
        },
        notEnabled: {
          description: 'Placeringsservices er ikke aktiveret eller tilladelse er ikke givet.',
          header: 'Placering ikke aktiveret',
        },
        notVerified: {
          description: 'GPS indikerer, at du ikke er på stedet.',
          header: 'Placering ikke bekræftet',
        },
        tryAgain: 'Prøv igen',
        unavailable: {
          description: 'Vi kunne ikke bekræfte din GPS-placering.',
          header: 'Placering utilgængelig',
        },
        unknown: {
          description: 'Vi kan ikke bestemme din placering.',
          header: 'Ukendt placering',
        },
        verified: {
          description: 'GPS indikerer, at du er på stedet.',
          header: 'Placering bekræftet',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Ingen aktiver fundet',
        emptyDescription: 'Der er ingen aktiver knyttet til denne arbejdsordre.',
        warrantyParts: 'Garanti for dele udløber',
        serialNumber: 'Serienummer',
        none: '<ingen>',
      },
      updates: {
        emptyTitle: 'Ingen opdateringer fundet',
        emptyDescription: 'Der er ingen opdateringer til denne arbejdsordre.',
        unknownUser: 'Ukendt bruger',
        none: 'Ingen',
        addComment: {
          buttonLabel: 'Tilføj kommentar',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Farlige forhold',
          no: 'Nej',
          yes: 'Ja',
        },
      },
    },
    attachmentsList: {
      attachments: 'Vedhæftninger',
      documents: 'Dokumenter',
      siteDocuments: 'Steddokumenter',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Farlige forhold',
        induction: 'Introduktion',
        safeToProceed: 'Sikker at fortsætte',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Forfaldsdato',
        activeSessions: 'Aktive sessioner',
        activeSessionsDescription:
          'Du er allerede tjekket ind på følgende arbejdsordrer. Du skal tjekke ud af disse arbejdsordrer, før du kan tjekke ind på en ny arbejdsordre.',
        resumeSession: 'Gendan',
        startTime: 'Startet kl.',
        unexpectedErrorTitle: 'Uventet fejl',
        unexpectedErrorMessage:
          'Der opstod en uventet fejl, mens der blev forsøgt at oprette dine sessioner. Prøv venligst igen senere.',
        engineerNotFound: 'Ingeniør ikke fundet',
        engineerNotFoundDescription:
          'Ingeniøren, du forsøger at tjekke ind, findes ikke i systemet. Kontakt venligst din administrator.',
      },
      verification: {
        code: {
          description:
            'For at tjekke ind, bedes du få den 4-cifrede kode fra stedets leder eller udpeget kontaktperson.',
        },
        geo: {
          continue: 'Fortsæt',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Hent venligst adgangskoden fra stedets leder eller udpegede kontaktperson for at fuldføre dit besøg.',
            checkOut: 'Tjek ud',
            completeBeforeLeaving: 'Udfyld venligst følgende formular, før du forlader.',
            continue: 'Fortsæt',
            noResolutionSelected: 'Vælg venligst en løsning, før du fortsætter.',
            quoteRequired: {
              hint: 'Besøg afsluttet, tilbud følger',
              label: 'Tilbud kræves',
            },
            returnVisitRequired: {
              hint: 'Vi vender tilbage for at afslutte',
              label: 'Tilbagebesøg kræves',
            },
            serviceCompleted: {
              hint: 'Ingen yderligere handling kræves',
              label: 'Service afsluttet',
            },
            uploadCheckout: 'Upload en fil, foto eller video',
            visitNotes: 'Besøgsnoter',
            workOrderResolution: 'Løsning på arbejdsordren',
            enterNotes: 'Indtast eventuelle noter her...',
            errors: {
              timedOut: 'Tidsgrænse overskredet, mere end 30 sekunder. Prøv venligst igen.',
              closingSession: 'Fejl ved afslutning af session',
            },
          },
          success: {
            description:
              'Tak for dit besøg på {site}. | {site} har stadig 1 åben arbejdsordre tilbage. | {site} har stadig {count} åbne arbejdsordrer tilbage.',
            endVisit: 'Afslut besøg',
            header: 'Du har succesfuldt tjekket ud',
            viewWorkOrders: 'Tjek ind på en anden arbejdsordre',
          },
          verification: {
            code: {
              description:
                'For at tjekke ud, bedes du få den 4-cifrede kode fra stedets leder eller udpeget kontaktperson.',
              continue: 'Fortsæt',
            },
            geo: {
              checkOut: 'Tjek ud',
              continue: 'Fortsæt',
            },
          },
        },
        detail: {
          assets: 'Aktiver',
          call: 'Ring',
          checkOut: 'Tjek ud',
          closed: 'Lukket',
          details: 'Detaljer',
          dueBy: 'Forfaldsdato',
          manageEngineers: 'Administrer ingeniører',
          notAvailable: 'Ikke tilgængelig',
          pointOfContact: 'Kontaktperson',
          siteAccessTimes: 'Adgangstider til stedet',
          siteAccessInstructions: 'Adgangsinstruktioner',
          siteAddress: 'Stedadresse',
          siteNotes: 'Stednoter',
          siteTelephone: 'Stedtelefon',
          siteLocation: 'Stedplacering',
          updates: 'Opdateringer',
          more: 'Mere',
          mismatchErrorTitle: 'Fejl i arbejdsordren',
          mismatchErrorMessage:
            'Den arbejdsordre, du forsøger at få adgang til, stemmer ikke overens med den, du i øjeblikket er tjekket ind på. Kontroller venligst din arbejdsordre, og prøv igen.',
          siteDocuments: 'Steddokumenter',
          validFrom: 'Gyldig fra',
          validUntil: 'Gyldig indtil',
          documentName: 'Dokumentnavn',
          documentType: 'Dokumenttype',
          attachments: 'Filer til arbejdsordren',
          download: 'Download',
          workDetails: 'Arbejdsdetaljer',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Tilføj assistentingeniør',
            assistantEngineers: 'Assistentingeniører',
            description:
              'Af sikkerhedsmæssige årsager bedes du angive navnene på hver ingeniør på stedet.',
            editMainEngineer: 'Rediger hovedingeniør',
            errors: {
              creatingEngineer: 'Fejl ved oprettelse af ingeniør',
              creatingSession: 'Fejl ved oprettelse af session',
            },
            header: 'Ingeniører på stedet',
            mainEngineer: 'Hovedingeniør',
            newAssistantEngineer: 'Indtast deres fulde navn',
            next: 'Næste',
            removeEngineer: 'Fjern ingeniør',
            selectExistingAssistantEngineer: 'Begynd at skrive deres navn',
          },
          index: {
            description:
              'Af sikkerhedsmæssige årsager bedes du angive navnene på hver ingeniør på stedet.',
            errorCreatingEngineer: 'Fejl ved oprettelse af ingeniør, prøv venligst igen.',
            header: 'Ingeniører på stedet',
            hintMainEngineer: 'Indtast hovedingeniørens fulde navn',
            newMainEngineer: 'Ny hovedingeniør',
            next: 'Næste',
            selectExistingMainEngineer: 'Vælg en eksisterende hovedingeniør',
            yes: 'Ja',
            no: 'Nej',
            mainEngineerLabel: 'Er du hovedingeniøren?',
          },
        },
        index: {
          callUsOn: 'Ring til os på {phoneNumber}',
          description: 'Kan du ikke finde det, du leder efter?',
          dueBy: 'Forfaldsdato',
          header: 'Vælg arbejdsordre',
          notAvailable: 'Ikke tilgængelig',
          searchWorkOrders: 'Søg i arbejdsordrer...',
        },
        manageEngineers: {
          manageEngineers: 'Administrer ingeniører',
          notWorking: 'Inaktive medarbejdere',
          pause: 'Pause',
          resume: 'Genoptag',
          workingNow: 'Aktive medarbejdere',
          startTime: 'Starttid',
          endTime: 'Sluttid',
          duration: 'Varighed',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Feedback',
            feedbackDescription:
              'Giv venligst feedback på arbejdsordren for at hjælpe os med at forbedre vores tjenester.',
            feedbackLabel: 'Feedback',
            filesLabel: 'Vedhæftninger',
            submissionLabel: 'Indsend feedback',
          },
          hazards: {
            back: 'Gå tilbage',
            hazards: 'Farlige forhold',
            next: 'Næste',
            no: 'Nej',
            noTasksForHazard: 'Der er ingen opgaver at fuldføre for denne fare.',
            yes: 'Ja',
          },
          induction: {
            continue: 'Fortsæt',
            induction: 'Introduktion',
          },
          index: {
            checkIn: 'Tjek ind',
            description: 'Udfyld venligst følgende risikovurdering for det valgte arbejde.',
            fail: 'Fejl ved behandling af start arbejdsordre tjek.',
            haltMessage:
              'Potentielle risici opdaget. Stop venligst arbejdet, gennemgå sikkerhedsinstrukserne, og kontakt din supervisor for yderligere instrukser.',
            header: 'Tjek før arbejde',
            endVisit: 'Afslut besøg',
            leaveFeedback: 'Efterlad feedback',
          },
          safeToProceed: {
            continue: 'Fortsæt',
            safeToProceed: 'Sikker at fortsætte',
          },
        },
      },
    },
    index: {
      title: 'Velkommen',
      description: 'Scan QR-koden på din placering for at komme i gang.',
    },
    login: {
      errorTitle: 'Uventet fejl',
      errorMessage: 'Der opstod en uventet fejl. Prøv venligst at scanne QR-koden igen.',
    },
    unauthenticated: {
      welcome: {
        title: 'Velkommen til {site}',
        description:
          'Før vi kan vise dig nogen arbejdsordrer, skal vi verificere dine oplysninger. Klik på knappen nedenfor for at fortsætte.',
        next: 'Fortsæt',
      },
      index: {
        errorTitle: 'Uventet fejl',
        errorMessage: 'Der opstod en uventet fejl. Prøv venligst at scanne QR-koden igen.',
      },
      contractor: {
        title: 'Hvem arbejder du for?',
        contractor: 'Entreprenør',
        contractorLabel: 'Begynd at skrive dit firmanavn',
        contractorHint: 'Du skal indtaste 3 tegn eller flere for at se resultater',
        defaultSelectPlaceholder: '--Vælg venligst--',
        next: 'Næste',
      },
      user: {
        title: 'Hvem er du?',
        cancel: 'Annuller',
        createNewUserLabel: 'Mit navn er ikke på listen',
        existingUserLabel: 'Begynd at skrive dit navn',
        existingUserHint: 'Du skal indtaste 3 tegn eller flere for at se resultater',
        newUserLabel: 'Indtast dit fulde navn',
        next: 'Næste',
        user: 'Bruger',
      },
      verification: {
        methods: {
          add: {
            add: 'Tilføj verificeringsmetode',
            defaultSelectPlaceholder: '--Vælg venligst--',
            emailLabel: 'E-mail',
            existingMethodWarning:
              'Du har allerede en ventende anmodning om denne verificeringsmetode, der afventer administratorens godkendelse. Tilføjelse af en ny vil overskrive den.',
            method: 'Metode',
            methodLabel: 'Metode',
            mobileCountryHint: 'Vælg venligst din landekode',
            mobileCountryLabel: 'Mobil landekode',
            mobileHint: 'Indtast venligst dit mobilnummer',
            mobileLabel: 'Mobil',
            title: 'Tilføj verificeringsmetode',
          },
          confirm: {
            confirm: 'Bekræft',
            description: 'Bekræft venligst din verificeringsmetode for at fortsætte.',
            label: 'Indtast din kode',
            resend: 'Gensend',
            resendPrompt: 'Modtog du ikke en kode?',
            title: 'Bekræft verificeringsmetode',
          },
          confirmed: {
            description:
              'Du vil blive underrettet, når denne verificeringsmetode er blevet godkendt af din administrator, og du kan derefter begynde at bruge den til at verificere din identitet.',
            forceApproval: 'Indtil den er godkendt, kan du ikke få adgang til arbejdsordrer.',
            nonForceApproval:
              'I mellemtiden kan du fortsætte med at få adgang til arbejdsordrer med begrænset adgang.',
            nonForceApprovalButtonLabel: 'Fortsæt med begrænset adgang',
            title: 'Afventer godkendelse',
          },
          addNew: 'Tilføj ny verificeringsmetode',
          description:
            'Vi skal verificere din identitet for at give dig fuld adgang til arbejdsordren.',
          email: 'E-mail',
          hint: 'Vi sender et link til din valgte verificeringsmetode, som giver dig fuld adgang til arbejdsordren. Hvis du har brug for at ændre nogen eksisterende verificeringsmetoder, bedes du kontakte din administrator.',
          label: 'Vælg en verificeringsmetode',
          next: 'Næste',
          pendingHint: 'Afventer godkendelse fra din administrator',
          sms: 'SMS',
          title: 'Verificering',
        },
        optional: {
          hint: 'Verificering af dine brugeroplysninger vil give dig fuld adgang til arbejdsordren',
          label: 'Ønsker du at verificere dine brugeroplysninger?',
          next: 'Næste',
          no: 'Nej',
          noHint:
            'Jeg ønsker ikke at verificere mine brugeroplysninger og fortsætte med begrænset adgang til arbejdsordren',
          title: 'Verificering',
          yes: 'Ja',
          yesHint:
            'Jeg ønsker at verificere mine brugeroplysninger og få fuld adgang til arbejdsordren',
        },
        sent: {
          description:
            'Et loginlink er blevet sendt til {identifier}. Klik venligst på linket for at fuldføre din login.',
          title: 'Loginlink sendt',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'I går',
      today: 'I dag',
      days: {
        monday: 'Mandag',
        tuesday: 'Tirsdag',
        wednesday: 'Onsdag',
        thursday: 'Torsdag',
        friday: 'Fredag',
        saturday: 'Lørdag',
        sunday: 'Søndag',
      },
      months: {
        january: 'Januar',
        february: 'Februar',
        march: 'Marts',
        april: 'April',
        may: 'Maj',
        june: 'Juni',
        july: 'Juli',
        august: 'August',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'December',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Noget gik galt',
      message: 'Prøv venligst at scanne QR-koden igen.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Ukendt bruger',
      },
      none: 'Ingen',
      types: {
        stateTransition: 'Status ændret',
        contractorAssigned: 'Entreprenør tildelt',
        engineerAssigned: 'Ingeniør tildelt',
        serviceAssigned: 'Service tildelt',
        priorityChanged: 'Prioritet ændret',
        actionableDateChanged: 'Handlingsdato ændret',
        dueDateChanged: 'Forfaldsdato ændret',
        etaDateChanged: 'Forventet ankomstdato ændret',
        spendLimitApproved: 'Forbrugsgrænse godkendt',
        spendLimitCancelled: 'Anmodning om forbrugsgrænse annulleret',
        spendLimitRejected: 'Forbrugsgrænse afvist',
        spendLimitRequested: 'Forbrugsgrænse anmodet',
        jobSheetUploaded: 'Jobseddel uploadet',
        slaAlertSent: 'Tidsfrist for opmærksomhed overskredet SLA-advarsel',
        issuedWorkPermit: 'Arbejdstilladelse udstedt',
        requestForServiceSent: 'Serviceanmodning sendt',
        comment: 'Kommentar tilføjet',
        unknown: 'Ukendt hændelse',
      },
      labels: {
        actionableDate: 'Handlingsdato',
        comment: 'Kommentar',
        file: 'Fil',
        contractor: 'Entreprenør',
        dueDate: 'Forfaldsdato',
        etaDate: 'Forventet ankomstdato',
        engineer: 'Ingeniør',
        priority: 'Prioritet',
        requestForService: 'Serviceanmodning',
        service: 'Service',
        spendLimit: 'Forbrugsgrænse',
        status: 'Status',
        workPermit: 'Arbejdstilladelse',
      },
    },
  },
}
